import { FC } from 'react';
import { app, settings } from '../../../@xmcloud/core/messages/en';
import { Stack } from '@chakra-ui/react';
import { HeadingSm, XMCSH3 } from '../../shared-components';
import { FeatureTogglesPage } from './FeatureTogglesPage';

const { featureToggles } = settings;
const { settings: settingstxt } = app;

export const SettingsPage: FC = () => {
	return (
		<Stack gap={4}>
			<XMCSH3 title={settingstxt} />
			<HeadingSm text={featureToggles} />
			<FeatureTogglesPage />
		</Stack>
	);
};
